import { FC, PropsWithChildren, createContext, useContext } from 'react';
import MessagingService from '../../services/MessagingService';
import { ChatChannelStateType, ChatMessagingStateType } from './models';
import {
  useKaiinChatChannelState,
  useKaiinChatMessagingService,
  useKaiinChatMessagingState,
  useKaiinImageService
} from './KaiinChatMessagingProvider';
import {
  useLineChatMessagingService,
  useLineChatMessagingState,
  useLineChatChannelState,
  useLineImageService
} from './LineChatMessagingProvider';
import React from 'react';
import ImageService from '../../services/ImageService';

type MessagingContext = {
  useChatMessagingService: () => MessagingService;
  useImageService: () => ImageService;
  useChatMessagingState: () => ChatMessagingStateType;
  useChatChannelState: () => ChatChannelStateType;
};

const CurrentMessagingServiceContext = createContext<Partial<MessagingContext>>(
  {}
);

const CurrentChatMessagesProvider: FC<PropsWithChildren<{ type: string }>> = ({
  children,
  type
}) => {
  let service: MessagingContext;
  switch (type) {
    case 'line':
      service = {
        useChatMessagingService: useLineChatMessagingService,
        useImageService: useLineImageService,
        useChatMessagingState: useLineChatMessagingState,
        useChatChannelState: useLineChatChannelState
      };
      break;
    default:
      service = {
        useChatMessagingService: useKaiinChatMessagingService,
        useImageService: useKaiinImageService,
        useChatMessagingState: useKaiinChatMessagingState,
        useChatChannelState: useKaiinChatChannelState
      };
      break;
  }
  return (
    <CurrentMessagingServiceContext.Provider value={service}>
      {children}
    </CurrentMessagingServiceContext.Provider>
  );
};

const useCurrentMessagingServiceContext = () =>
  useContext(CurrentMessagingServiceContext);

export { CurrentChatMessagesProvider, useCurrentMessagingServiceContext };
